<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface Card {
  id: string
  title: string
  description: string
}

interface CardRow {
  gridClass: string
  cards: Card[]
}

const cardRows = computed<CardRow[]>(() => [
  {
    gridClass:
      'grid grid-cols-1 lg:grid-cols-[53.28%_43.59%] gap-4 lg:gap-[3.12%] w-full  mx-auto',
    cards: [
      {
        id: 'reviews-management',
        title: t('feature_reviews_management'),
        description: t('feature_reviews_management_description'),
      },
      {
        id: 'limits-search',
        title: t('feature_limits_search'),
        description: t('feature_limits_search_description'),
      },
    ],
  },
  {
    gridClass:
      'grid grid-cols-1 lg:grid-cols-[43.59%_53.28%] gap-4 lg:gap-[3.12%]',
    cards: [
      {
        id: 'repricer',
        title: t('feature_repricer'),
        description: t('feature_repricer_description'),
      },
      {
        id: 'autobidder',
        title: t('feature_autobidder'),
        description: t('feature_autobidder_description'),
      },
    ],
  },
  {
    gridClass:
      'grid grid-cols-1 lg:grid-cols-[53.28%_43.59%] gap-4 lg:gap-[3.12%]',
    cards: [
      {
        id: 'ai-dialog',
        title: t('feature_ai_dialog'),
        description: t('feature_ai_dialog_description'),
      },
      {
        id: 'profit-calculator',
        title: t('feature_profit_calculator'),
        description: t('feature_profit_calculator_description'),
      },
    ],
  },
])
</script>

<template>
  <section class="container mx-auto flex flex-col gap-4 lg:gap-10">
    <div
      v-for="(row, rowIndex) in cardRows"
      :key="rowIndex"
      :class="row.gridClass"
    >
      <div
        v-for="(card, cardIndex) in row.cards"
        :key="card.id"
        :data-aos="rowIndex % 2 === 0 ? 'fade-right' : 'fade-left'"
        :data-aos-duration="800"
        :data-aos-delay="100 + rowIndex * 200 + cardIndex * 100"
        class="bg-white rounded-xl md:rounded-2xl px-4 md:px-10 h-full py-6 md:py-8 shadow-sm text-center md:text-left"
      >
        <h3
          class="font-semibold text-2xl sm:text-[32px] leading-9 sm:leading-[58px] text-[#172026] mb-3 sm:mb-2"
        >
          {{ card.title }}
        </h3>
        <p class="text-sm sm:text-lg leading-6 sm:leading-7 text-[#36485C]">
          {{ card.description }}
        </p>
      </div>
    </div>
  </section>
</template>
